import { render, staticRenderFns } from "./ReorderContentDepthsModal.vue?vue&type=template&id=1fe879f5&lang=pug&"
import script from "./ReorderContentDepthsModal.vue?vue&type=script&lang=js&"
export * from "./ReorderContentDepthsModal.vue?vue&type=script&lang=js&"
import style0 from "./ReorderContentDepthsModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports